export default __webpack_public_path__ + "static/demo-screen-1-370d7c4a044cc5fc60c0746ee71ae2b5.jpg";